import { Box, HStack } from '@chakra-ui/react'
import { Fax, isSentFax, WithId } from '@hb/shared'

import { doc, setDoc } from 'firebase/firestore'

import { FAX_RECEIVED_REF, FAX_SENT_REF } from '../../backend/db/collections'
import { EditableNotesPopover } from '../NotesPopover'
import { AssignToPatient } from './AssignToPatient'
import { ReSendFax } from './ReSendFax'

export const FaxModalHeader = ({ fax }: { fax: WithId<Fax> }) => (
  <HStack flex={3} px={2} pr={10} minW={0}>
    <Box flex={1} minW={0}>
      <EditableNotesPopover
        onSubmit={v =>
          setDoc(
            doc(fax.type === 'received' ? FAX_RECEIVED_REF : (FAX_SENT_REF as any), fax.id),
            { notes: v },
            { merge: true },
          )
        }
        notes={fax.notes}
      />
    </Box>

    <Box minW={0} flex={1}>
      <AssignToPatient size="sm" fax={fax} />
    </Box>
    {isSentFax(fax) && <ReSendFax fax={fax} />}
  </HStack>
)
